<template>
  <div class="light-refraction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box" @mousemove="handleMouseMove">
      <svg width="100%" height="400" viewBox="0 0 400 400">
        <!-- 界面 -->
        <rect x="0" y="200" width="400" height="200" :fill="mediumColor" opacity="0.3" />
        <line x1="0" y1="200" x2="400" y2="200" stroke="#00d2ff" stroke-width="2" />
        <line x1="200" y1="0" x2="200" y2="400" stroke="#555" stroke-dasharray="4,4" /> <!-- 法线 -->

        <!-- 入射光 -->
        <line :x1="incidentX" :y1="incidentY" x2="200" y2="200" stroke="#ffff00" stroke-width="3" />
        <!-- 折射光 -->
        <line x1="200" y1="200" :x2="refractedX" :y2="refractedY" stroke="#ffff00" stroke-width="3" />
        
        <!-- 角度标注 -->
        <text x="210" y="170" fill="#aaa" font-size="12">θ1 = {{ angle1.toFixed(1) }}°</text>
        <text x="210" y="240" fill="#aaa" font-size="12">θ2 = {{ angle2.toFixed(1) }}°</text>
      </svg>
    </div>

    <div class="formula-box" v-latex>
       $n_1 \sin \theta_1 = n_2 \sin \theta_2$
    </div>
  </div>
</template>

<script>
export default {
  name: 'LightRefractionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      medium1: 1.0, // 空气
      medium2: 1.5,
      mouseX: 100,
      mouseY: 100
    }
  },
  computed: {
    mediumColor() {
       if(this.medium2 < 1.4) return '#1e90ff';
       return '#70a1ff';
    },
    angle1() {
       const dx = 200 - this.mouseX;
       const dy = 200 - this.mouseY;
       return Math.atan2(dx, dy) * 180 / Math.PI;
    },
    angle2() {
       const theta1 = (this.angle1 * Math.PI / 180);
       const sinTheta2 = (this.medium1 * Math.sin(theta1)) / this.medium2;
       return Math.asin(sinTheta2) * 180 / Math.PI;
    },
    incidentX() { return this.mouseX; },
    incidentY() { return this.mouseY; },
    refractedX() {
       const theta2 = this.angle2 * Math.PI / 180;
       return 200 + Math.sin(theta2) * 150;
    },
    refractedY() {
       const theta2 = this.angle2 * Math.PI / 180;
       return 200 + Math.cos(theta2) * 150;
    }
  },
  methods: {
    handleMouseMove(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - rect.left) * (400 / rect.width);
      const y = (e.clientY - rect.top) * (400 / rect.height);
      if (y < 200) { this.mouseX = x; this.mouseY = y; }
    }
  }
}
</script>

<style scoped lang="scss">
.light-refraction-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #0a0a0a; border-radius: 8px; cursor: crosshair; }
.formula-box { text-align: center; color: #00d2ff; font-family: 'Times New Roman', Times, serif; font-size: 1.2rem; }
</style>
